import {Col, Row} from "antd";
import styled from "styled-components";

export const Container = styled(Row)`
    width: 100%;
    height: max(calc(100vh - 120px), 500px);
    justify-content: center;

    @media screen and (max-width: 992px) {
        flex-direction: row-reverse;
    }
`;

// New customer-specific container
export const CustomerContainer = styled(Row)`
    width: 100%;
    height: calc(100vh - 120px); // Increased height for better space utilization
    max-height: calc(100vh - 120px);
    justify-content: center;
    overflow: hidden;

    @media screen and (max-width: 992px) {
        flex-direction: row-reverse;
        height: calc(100vh - 100px);
        max-height: calc(100vh - 100px);
    }

    @media screen and (max-width: 768px) {
        height: calc(100vh - 90px);
        max-height: calc(100vh - 90px);
    }
`;

export const FormContainer = styled(Col)`
    height: 100%;
    overflow: auto;
    @media screen and (max-width: 992px) {
        height: 80%;
    }
`;

// Customer-specific form container
export const CustomerFormContainer = styled(Col)`
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    @media screen and (max-width: 992px) {
        height: 80%; // Increased height for mobile to give more space to form
    }
`;

export const MapContainer = styled(Col)`
    border: 5px solid #b2fc35;
    height: 100%;
    @media screen and (max-width: 992px) {
        height: 20%;
    }
`;

// Customer-specific map container
export const CustomerMapContainer = styled(Col)`
    border: 5px solid #b2fc35;
    height: 100%;
    @media screen and (max-width: 992px) {
        height: 20%; // Reduced to balance with increased form height
    }
`;
